<template>
  <div>
    <dynamic-layout />
  </div>
</template>

<script>
import DynamicLayout from '@/components/layout/TheDynamicLayout.vue';

export default {
  name: 'Dashboard',
  components: {
    DynamicLayout,
  },
};
</script>
